import { useEffect, useRef, useState } from 'react';
import StickyBox from 'react-sticky-box';

// import MobileDetect from 'mobile-detect';
import CardH from 'src/components/cards/card-h';
import CardV from 'src/components/cards/card-v';
import Layout from 'src/components/layouts';
import WidgetLottoCheck from 'src/components/widgets/widget-lotto-check';
import WidgetLottoResult from 'src/components/widgets/widget-lotto-result';
import client from 'src/utils/client';
// import SectionFullH from 'src/components/sections/section-full-h';
import parse from 'html-react-parser';
import { isShouldFetch } from 'src/utils/detect-scrolling';

import _ from 'lodash';
import { NextSeo } from 'next-seo';
import SEO from 'next-seo.config';
import Head from 'next/head';
import { useRouter } from 'next/router';
import PageError from 'pages/404';
import WidgetBreadcrumb from 'src/2.0/widgets/widget-breadcrumb';
import { APP_IMG, APP_URL, SHOW_COMMEMORATE } from 'src/constants';
import { IMAGE_DEFAULT, WEB_DESC, WEB_NAME, WEB_TITLE, WEB_URL } from 'src/constants/layout';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { useDesktop } from 'src/utils/device';
import { GET } from 'src/utils/services';
import useUser from 'src/utils/useUser';
import WidgetHeading from 'src/2.0/widgets/widget-heading';
const PageLottery = ({ articles, nextArticles, lastNews, meta, dataAdsHeader }) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  // console.log(articles);
  if (articles === null) {
    return <PageError dataAdsHeader={dataAdsHeader} sessionSevId={sessionSevId} />;
  }
  const router = useRouter();

  const nextLinkRef = useRef(nextArticles?.next);
  const listArticlesRef = useRef(articles);
  const [listArticles, setListArticles] = useState(articles);
  const [isFetching, setIsFetching] = useState(false);

  const handleScroll = async () => {
    if (isShouldFetch()) {
      document.removeEventListener('scroll', handleScroll);
      await loadMoreArticles();
    }
  };

  const loadMoreArticles = async () => {
    try {
      if (nextArticles?.next !== null) {
        setIsFetching(true);
        const resData = await GET(`${nextLinkRef?.current}`, false, true);
        if (!_.isEmpty(resData?.data)) {
          nextLinkRef.current = resData?.links?.next;
          listArticlesRef.current = [...listArticlesRef.current, ...resData?.data];

          setListArticles(listArticlesRef.current);

          if (isShouldFetch()) {
            await loadMoreArticles();
          } else {
            document.addEventListener('scroll', handleScroll);
          }
        }
      }
    } catch (error) {
      console.error('==========> LOAD_MORE ERROR', error.message);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    document.addEventListener('scroll', handleScroll);
    return () => document.removeEventListener('scroll', handleScroll);
  }, []);

  const baseUrlCategory = `${APP_URL}/lottery}`;
  const _article = {
    title: meta?.title,
    description: meta?.description,
    keyword: meta?.keyword
  };

  // const titlePage = 'สลากกินแบ่งรัฐบาล';
  // const articleTitle = escapeChar(meta.title);
  // const articleDescription = escapeChar(meta.abstract);

  // const { cid } = router.query;
  // console.log(category, subCategory);
  // console.log(nextLinkRef);
  // const titleEscape = escapeChar(meta.title);
  // console.log(articles);
  return (
    <>
      {/* -------------------------------- NEXT_SEO -------------------------------- */}
      <NextSeo
        {...SEO}
        title={_article?.title}
        description={_article?.description}
        robotsProps={{
          maxImagePreview: 'large',
          maxSnippet: -1,
          maxVideoPreview: -1
        }}
        openGraph={{
          ...SEO.openGraph,
          title: _article?.title,
          description: _article?.description,
          url: baseUrlCategory
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: _article?.keyword
          }
        ]}
      />
      {/* --------------------------------- HEADER --------------------------------- */}
      <Head>
        <link rel='canonical' href={baseUrlCategory} />
        <meta property='twitter:title' content={_article?.title || WEB_TITLE} />
        <meta property='twitter:description' content={_article?.description || WEB_DESC} />
        <meta property='twitter:image' content={IMAGE_DEFAULT} />
        {/* ----------------------------- ScriptBrowser ------------------------------------ */}
        {!useDesktop() && !_.isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_mobile}`) : ''}
        {useDesktop() && !_.isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_desktop}`) : ''}
        {/* ----------------------------- ADS : PPN ------------------------------- */}
        <script async type='text/javascript' src='https://securepubads.g.doubleclick.net/tag/js/gpt.js' />
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: 'var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];'
          }}
        />
        {/* --------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `
                 __th_page="lottery";
            `
          }}
        />

        {/* ---------------------------- SPIPPET : WebSite --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
              {
                "@context": "https://schema.org",
                "@type": "WebSite",
                "name": "${WEB_NAME}",
                "url": "${WEB_URL.WEB}",
                "description": "${_article?.description || WEB_DESC}",
                "sameAs": [
                  "${WEB_URL.FACEBOOK}",
                  "${WEB_URL.TWITTER}",
                  "${WEB_URL.YOUTUBE}",
                  "${WEB_URL.LINE}"
                ],
                "potentialAction": {
                  "@type": "SearchAction",
                  "target": "${WEB_URL.WEB}search?q={search_term_string}",
                  "query-input": "required name=search_term_string"
                }
              }
            `
          }}
        />

        {/* ---------------------------- SPIPPET : WebPage --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
                {
                  "@context": "http://schema.org",
                  "@type": "WebPage",
                  "name": "lottery",
                  "description": "${_article?.description || WEB_DESC}",
                  "publisher": {
                    "@type": "ProfilePage",
                    "name": "${WEB_NAME}"
                  }
                }
              `
          }}
        />

        {/* ------------------------ SPIPPET : BreadcrumbList ------------------------ */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
              {
                "@context": "http://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "หน้าแรก",
                    "item": "${APP_URL}"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "l",
                    "item": "${APP_URL}/lottery"
                  }
                ]
              }
            `
          }}
        />
      </Head>
      {/* -------------------------------------------------------------------------- */}

      <Layout sessionSevId={sessionSevId}>
        <div id='section-1' className='category-wrapper' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-8 col-md-12'>
                <WidgetBreadcrumb
                  article={{
                    section: { th: 'สลากกินแบ่งรัฐบาล', en: 'lottery' }
                  }}
                />
                <h1 className='heading-title'>สลากกินแบ่งรัฐบาล</h1>
                <div className='row'>
                  {articles.length < 1 ? (
                    <div className='col-12 no-article'>
                      <img src={`${APP_IMG}/no-article.png`} alt='no-article' width='100%' />
                    </div>
                  ) : (
                    <>
                      <div className='col-12'>
                        <WidgetLottoResult />
                      </div>
                      {listArticles.map((item, index) => (
                        <div key={index} id={index + 1} className='col-6 col-md-4 mb-3'>
                          <CardV
                            data={item}
                            description={false}
                            path={`/lottery/${item.dateDefault}`}
                            //! DATALAYER
                            eventDataLayer={{
                              type: DATALAYER_TYPE.TRACK_POSITION,
                              router: router?.pathname,
                              section: 'ข่าวทั้งหมด',
                              position: 'ใต้:header',
                              data: {
                                block: '1',
                                title: item.title,
                                heading: 'สลากกินแบ่งรัฐบาล',
                                index: index + 1
                              }
                            }}
                          />
                        </div>
                      ))}
                    </>
                  )}
                  {isFetching && 'Fetching more list items...'}
                </div>
              </div>

              <div className='col-lg-4 col-md-12 d-lg-block d-none'>
                <StickyBox offsetTop={70} offsetBottom={70}>
                  <WidgetLottoCheck
                    //! DATALAYER
                    eventDataLayer={{
                      type: DATALAYER_TYPE.TRACK_POSITION,
                      router: router?.pathname,
                      section: 'ตรวจผลสลากกินแบ่งรัฐบาล',
                      position: 'ใต้:header'
                    }}
                  />
                  <div className='widget-content'>
                    <WidgetHeading heading='Latest News' />
                    <div className='block-content'>
                      {Array.isArray(lastNews) && lastNews.length < 1 ? (
                        <div className='no-article'>
                          <img className='--side' src={`${APP_IMG}/no-article.png`} alt='no-article' width='100%' />
                        </div>
                      ) : (
                        <ul className='block-list'>
                          {lastNews.slice(0, 4).map((item, index) => (
                            <li key={index}>
                              <CardH
                                data={item}
                                large={false}
                                //! DATALAYER
                                eventDataLayer={{
                                  type: DATALAYER_TYPE.TRACK_POSITION,
                                  router: router?.pathname,
                                  section: 'Latest News',
                                  position: 'ใต้:ตรวจผลสลากกินแบ่งรัฐบาล',
                                  data: {
                                    block: '2',
                                    title: item.title,
                                    heading: 'Latest News',
                                    index: index + 1
                                  }
                                }}
                              />
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </StickyBox>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export async function getServerSideProps({ req, res, query }) {
  const initProps = {
    statusCode: 200,
    errMessage: null,
    articles: null,
    nextArticles: null,
    lastNews: null,
    meta: null,
    dataAdsHeader: null
  };
  const scriptBrowser = await GET('/api/headerAds');
  if (!_.isEmpty(scriptBrowser)) {
    initProps.dataAdsHeader = scriptBrowser || '';
  }
  try {
    const { data } = await client.fetch.get('/api/v1.0/lottory');
    // console.log(data);
    if ('msg' in data) {
      initProps.articles = null;
    } else {
      initProps.articles = data.data;
      initProps.nextArticles = data.links;
      initProps.lastNews = data.lastNews;
      initProps.meta = data.meta;
    }
  } catch (err) {
    // console.log('==========> CATEGORY ERROR', err.message);
    initProps.errMessage = err.message;
    initProps.statusCode = err?.response?.status || 500;
  }
  return {
    props: initProps
  };
}

export default PageLottery;
